// Root layout — body{display:flex} pattern matching legacy stbarts
// (index.html L1662-1815). Sidebar (260px, collapsible) on the left,
// main-wrapper on the right with toolbar + content + kanban view.
// ContextOverlayPopup floats on top when a remark is selected.

import { Show, createEffect, onMount } from 'solid-js';
import { actions, bootErrorSignal, stores } from '../state/store';
import { installUrlWriter, restoreFromUrl } from '../state/urlSync';
import { ContextOverlayPopup } from './ContextOverlayPopup';
import { KanbanView } from './KanbanView';
import { LoadingState } from './LoadingState';
import { LoginForm } from './LoginForm';
import { MainView } from './MainView';
import { Sidebar } from './Sidebar';
import { Toast } from './Toast';

export function App() {
  let urlRestoreDone = false;
  onMount(() => {
    installUrlWriter();
    void actions.boot();
  });
  // Run restoreFromUrl once, as soon as targets are available — covers both
  // the auto-boot path (returning user with persisted token) and the post-
  // login path (LoginForm -> actions.login -> loadProjects -> targets ready).
  createEffect(() => {
    if (urlRestoreDone) return;
    if (stores.state.targets.length === 0) return;
    urlRestoreDone = true;
    void restoreFromUrl();
  });

  return (
    <Show
      when={!bootErrorSignal()}
      fallback={<div class="boot-error">Boot error: {bootErrorSignal()}</div>}
    >
      <Show when={!stores.state.bootLoading} fallback={<LoadingState variant="app" />}>
        <Show when={stores.auth.email} fallback={<LoginForm />}>
          <Sidebar />
          <div class="main-wrapper">
            <Show
              when={stores.state.viewMode === 'kanban'}
              fallback={<MainView />}
            >
              <KanbanView />
            </Show>
          </div>
          <ContextOverlayPopup />
        </Show>
      </Show>
      <Toast />
    </Show>
  );
}
